import Auth from '@Services/Auth';
import RequestUrls from '@Constants/RequestUrlsConstants';
import MessageBroker from '@Services/MessageBroker';

const ipAddress = null;

class RegisterData {
  static getIpAddress() {
    if (ipAddress) {
      return Promise.resolve(ipAddress);
    }
    return Auth.getClientInfo()
      .then((data) => Auth.changeUserProfile(false, data))
      .then((profile) => {
        return profile.clientInfo.ipAddress;
      })
      .catch(Logger.reject);
  }

  static register(data) {
    if (data.bulkId && data.bulkPassword) {
      // request to public service, authorization is not required
      return MessageBroker.send(RequestUrls.userRegisterWithBulkId, data, { Authorization: false });
    }
    return MessageBroker.send(RequestUrls.simpleUserRegister, data);
  }

  static getCombinedInfo() {
    // request to public service, authorization is not required
    return MessageBroker.send(RequestUrls.publicCombinedInfo, null, { Authorization: false });
  }
}

export default RegisterData;
